import React from "react";
import Products from "../Components/Products";
import "./home.css";
import Diversity1Icon from "@mui/icons-material/Diversity1";
const Home = () => {
  return (
    <div>
      <div className="title_screen">
        <h2 className="heading">Welcome to eShop.here !! </h2>
        <p style={{ display: "flex", padding: "5px", gap: "5px" }}>
          Best Fashion for best of kind
          <Diversity1Icon style={{ fontSize: "2vw" }} />
        </p>
      </div>
      <section>
        <h3>
          <Products />
        </h3>
      </section>
    </div>
  );
};

export default Home;
